<div class="wrapper__headerComponent container my-5">
  <div class="contenedor-tabla w-100">
    <div class="d-flex flex-row justify-content-between mb-5">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{'gestion-usuarios.perfil-empresa' | translate}}
      </h2>
      <div>
        <button
          class="btn-govco outline-btn-govco"
          (click)="agregar()"
          aria-label="Agregar usuario gestor">
          <i class="govco-plus-square-1"></i>
          {{ 'gestion-usuarios.agregar' | translate }}
        </button>
      </div>
    </div>
    <app-table
      *ngIf="!mostrarFormulario"
      [columnas]="columnasGestores"
      [paginacion]="true"
      [paginaActual]="paginaActual"
      [totalPaginas]="totalPaginas"
      [tamano]="tamanoPagina"
      [multipleSelection]="true"
      [datos]="gestores"
      (selectedItemsChange)="verificarSeleccion($event)"
      (evento)="filtrar($event)">
    </app-table>
    <div class="d-flex flex-row justify-content-end my-3"
         *ngIf="!mostrarFormulario">
      <div>
        <button
          class="btn-govco outline-btn-govco me-2"
          [disabled]="!sePuedeActualizar"
          (click)="modificar()"
          aria-label="Modificar usuario gestor">
          <i class="govco-edit-1"></i>
          {{ 'gestion-usuarios.modificar' | translate }}
        </button>
      </div>
      <div>
        <button
          class="btn-govco outline-btn-govco"
          [disabled]="!sePuedeEliminar"
          (click)="eliminar()"
          aria-label="Eliminar usuario gestor">
          <i class="govco-trash"></i>
          {{ 'gestion-usuarios.eliminar' | translate }}
        </button>
      </div>
    </div>
    <app-form *ngIf="mostrarFormulario"
              [fields]="camposFormGestores"
              (submitAction)="onSubmit($event)"
              [withSubmitButton]="true"
              [withCamposObligatorios]="true"
              [sumbitButtonText]="comunText['continuar']">
    </app-form>
  </div>
</div>
<app-modal-datos-observatorio></app-modal-datos-observatorio>